import { authConstants } from "@data/constants/authConstants"

export const saveAuthToken = (tokenData) => {
    return {
        type: authConstants.SAVE_AUTH_TOKEN,
        tokenData: {
            email: tokenData.email,
            token: tokenData.token,
            userId: tokenData.userId,
            displayName: tokenData.displayName,
            firstname: tokenData.firstname,
            lastname: tokenData.lastname,
            roles: tokenData.roles,
            avatar: tokenData.avatar,
            title_skill_set_id: tokenData.title_skill_set_id,
            hubspot_id: tokenData?.hubspot_id,
            // Le jeton d'une session impersonnée est marqué, pour que la sortie (ou la prochaine
            // impersonation) l'efface. Posé seulement quand il est vrai : la fusion du réducteur
            // ne doit jamais retirer la marque d'une entrée déjà marquée.
            ...(tokenData?.is_impersonation ? { is_impersonation: true } : {}),
        },
    }
}

export const removeAuthToken = (userId) => {
    return {
        type: authConstants.REMOVE_AUTH_TOKEN,
        userId,
    }
}

export const switchAccount = (tokenData) => {
    return {
        type: authConstants.SWITCH_ACCOUNT,
        tokenData,
    }
}

export const updateLastConnected = (user) => {
    return {
        type: authConstants.UPDATE_LAST_CONNECTED,
        user,
    }
}

/**
 * Wipes user-scoped redux slices (currentUser, family, liveSessions,
 * schoolAssessments, summer, studyMissions, …) while *intentionally*
 * preserving the `storedTokens` shelf in authTokens — that's the whole
 * point of this action: keep the multi-account credential store intact
 * so the next login / impersonation handoff still has the sibling tokens
 * to swap into. Despite the legacy `RESET_AUTH_STATE` name, this is NOT
 * a "log out everywhere" hook; reach for the logout flow if that's what
 * you need.
 */
export const resetAuthState = () => {
    return {
        type: authConstants.RESET_AUTH_STATE,
    }
}

/**
 * Stores what a redeemed login link opened. Its own action, not the request's
 * success: when another account is open, the person confirms first, and
 * nothing of the link's accounts may land before that.
 */
export const acceptLoginLink = (data) => {
    return {
        type: authConstants.ACCEPT_LOGIN_LINK,
        data,
    }
}
